import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(theme => ({
  blue: {
    background: theme.palette.common.infoTint,
    color: theme.palette.common.gray800,
  },
  green: {
    background: theme.palette.common.green100,
    color: theme.palette.common.green800,
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  orange: {
    background: theme.palette.common.orange100,
    color: theme.palette.common.orange800,
  },
  red: {
    background: theme.palette.common.red100,
    color: theme.palette.common.red800,
  },
  root: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1, 1.5),
  },
}));

export default useStyles;
